import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getLocalStorage } from "../../utils/localStorage";
import { DataGrid } from '@mui/x-data-grid';
import { Box } from "@mui/material";
import clsx from 'clsx';
import { findUserGifts } from "../../redux/action/giftActions";
export const GiftsHistory = () => {
    const clientId = getLocalStorage("user").clientId;
    const [gifts, setgifts]  = useState([]);
    const dispatch = useDispatch();
    useEffect($ =>{
          dispatch(findUserGifts(clientId, setgifts)) ;
    }, [ dispatch, clientId])

    const columns = [
        {
            field: 'date',
            headerName: 'Date',
            width: 110,
        },
        {
            field: 'fromClientId',
            headerName: 'Received from',
            width: 110,
            cellClassName: (params) =>
            clsx('super-app', {
               itself: params.value === clientId
            }),
        },
        {
            field: 'toClientId',
            headerName: 'Sent to',
            width: 110,
            cellClassName: (params) =>
            clsx('super-app', {
               itself: params.value === clientId
            }),
        },
        {
            field: 'instrument',
            headerName: 'Instrument',
            width: 110,
        },
        {
            field: 'price',
            headerName: 'Price',
            width: 110,
        },
        {
             field: 'quantity',
            headerName: 'Quantity',
            width: 110,
        }  
    ]

    return <>
    <h3>History</h3>
       <Box
        sx={{
            height: 500, width: '1',
            '& .super-app.itself': {
                visibility: 'hidden',
            }
        }}
    >
        <DataGrid
            columns={columns}
            rows={gifts}
            rowHeight={70}
            getRowId={(row) => row._id}
        />
    </Box>

    </>
}
